import { useState } from "react";

const useToken = () => {
  const getToken = () => localStorage.getItem("access_token");
  const getRefreshToken = () => localStorage.getItem("refresh_token");

  const [token, setToken] = useState(getToken());

  const saveToken = (accessToken, refreshToken) => {
    localStorage.setItem("access_token", accessToken);
    localStorage.setItem("refresh_token", refreshToken);
    setToken(accessToken); // Ensure state updates
  };

  const removeToken = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setToken(null);
  };

  const refreshAccessToken = async () => {
    const refreshToken = getRefreshToken();
    if (!refreshToken) {
      removeToken();
      // Redirect to login if no refresh token
      window.location.href = "/";
      return null;
    }

    try {
      const response = await fetch("/api/refresh", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refresh_token: refreshToken }),
        credentials: "include",
      });

      if (response.ok) {
        const data = await response.json();
        saveToken(data.access_token, data.refresh_token);
        return data.access_token;
      } else {
        removeToken();
        // Redirect to login if refresh failed
        window.location.href = "/";
        return null;
      }
    } catch (error) {
      console.error("Failed to refresh token:", error);
      removeToken();
      // Redirect to login on error
      window.location.href = "/";
      return null;
    }
  };

  return { token, saveToken, removeToken, refreshAccessToken, getToken };
};

export default useToken;
